import React from 'react';
import { Database, CheckCircle, AlertTriangle, XCircle } from 'lucide-react';
import BentoWidgetCard from '../BentoWidgetCard';
import { getDataFreshnessData } from '../../../../utils/aiBriefingsData';
interface DataFreshnessWidgetProps {
  onHide?: () => void;
}
const DataFreshnessWidget: React.FC<DataFreshnessWidgetProps> = ({
  onHide
}) => {
  const data = getDataFreshnessData();
  const getStatusIcon = (status: string) => {
    switch (status) {
      case 'ok':
        return <CheckCircle className="h-4 w-4 text-green-600" data-id="element-1329" />;
      case 'warning':
        return <AlertTriangle className="h-4 w-4 text-yellow-600" data-id="element-1330" />;
      case 'error':
        return <XCircle className="h-4 w-4 text-red-600" data-id="element-1331" />;
      default:
        return <Database className="h-4 w-4 text-gray-600" data-id="element-1332" />;
    }
  };
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'ok':
        return 'bg-green-50 border-green-200';
      case 'warning':
        return 'bg-yellow-50 border-yellow-200';
      case 'error':
        return 'bg-red-50 border-red-200';
      default:
        return 'bg-gray-50 border-gray-200';
    }
  };
  return <BentoWidgetCard id="data-freshness" title="Data Freshness & Copertura" size="S" lastUpdated="1 min fa" onHide={onHide} data-id="element-1333">
      <div className="space-y-2" data-id="element-1334">
        {data.sources.map((source, index) => <div key={index} className={`border rounded-lg p-2 ${getStatusColor(source.status)}`} data-id="element-1335">
            <div className="flex items-center justify-between mb-1" data-id="element-1336">
              <div className="flex items-center gap-2" data-id="element-1337">
                {getStatusIcon(source.status)}
                <p className="text-xs font-medium text-gray-900" data-id="element-1338">
                  {source.name}
                </p>
              </div>
              <span className="text-xs font-bold text-gray-900" data-id="element-1339">
                {source.coverage}%
              </span>
            </div>
            <p className="text-xs text-gray-600" data-id="element-1340">{source.lastUpdate}</p>
          </div>)}
      </div>
    </BentoWidgetCard>;
};
export default DataFreshnessWidget;